<script setup lang="ts">
import { getEnvVar } from '@/utils/env';
import Button from 'primevue/button';

interface Props {
  isFetching: boolean;
}
defineProps<Props>();

const BASE_URL = getEnvVar('VITE_CDN_BASE_URL');
const loadingIcon = `${BASE_URL}/assets/images/new_loading.jpg`;
</script>

<template>
  <div class="loading-modal room-fetching">
    <div v-if="isFetching">
      <div class="loading mb-3">
        <div class="vacv-loader">
          <img :alt="$t('common.generic.loading')" :src="loadingIcon" />
        </div>
      </div>
      <div class="text-center">
        <div>{{ $t('advance_quote.searching_room_title') }}</div>
        <div class="text-center mt-2">{{ $t('advance_quote.searching_room_desc') }}</div>
      </div>
    </div>
    <div v-else class="text-center">
      <div class="mb-4">{{ $t('advance_quote.no_room_title') }}</div>
      <div>{{ $t('advance_quote.no_room_desc') }}</div>
      <div class="flex w-full justify-content-center mt-3 -mb-3">
        <Button :label="$t('advance_quote.update_your_search')" class="button-submit bg-primary uppercase" @click="$emit('closeModal')"></Button>
      </div>
    </div>
  </div>
</template>
